import { render, staticRenderFns } from "./DamageAssessorCaseDocumentCardTab.vue?vue&type=template&id=07d96054&scoped=true"
import script from "./DamageAssessorCaseDocumentCardTab.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseDocumentCardTab.vue?vue&type=script&lang=js"
import style0 from "./DamageAssessorCaseDocumentCardTab.vue?vue&type=style&index=0&id=07d96054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d96054",
  null
  
)

export default component.exports